import React from 'react';
import Helmet from "react-helmet";
import {Card, Row, Col} from 'react-bootstrap';
import { Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import speaker3 from '../../assets/images/contents/speaker3.jpg';

export const AssociateProfessorDrSimonFong = () => (
  <div>
    <Helmet>
      <title>The 6th International Conference on Soft Computing in Data Science 2021 (SCDS2021) - Keynote Speaker</title>
    </Helmet>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link to="/scds2021/home">Home</Link></li>
        <li class="breadcrumb-item active" aria-current="page">AssociateProfessorDrSimonFong</li>
      </ol>
    </nav>

    <Container> 
      <Row className="justify-content-md-center">  
        <Col md="auto">
          <Card>
            <Card.Img width="100px" height="220px" src={speaker3} alt="speaker image" /> 
          </Card>             
        </Col>
      </Row>
    </Container>

    <p style={{textAlign:'center'}}>
      <b>Associate Professor Dr. Simon Fong</b>
    </p>

    <p style={{textAlign:'center'}}>
      University of Macau, China
    </p>

    <br/>

    <h4 style={{textAlign:'center'}}>XAI Early Cancer Detection Using Swarm Intelligence Marker-Based Watershed Segmentation Algorithm and Evolving 
      Graph Convolutional Network: Case of Lung Cancer Deep Analysis from Pulmonary Nodules and Cancer Images
    </h4>

    <p style={{ textAlign:'justify'}}><b>Abstract</b><br/>
      By merely relying on image processing and AI algorithms for early cancer detection, is insufficient. This talk covers the latest works we are 
      now dealing with by fusing longitudinal big data and personalized data from biomarkers and tumour growth dynamic simulation for early cancer 
      detection. AI are just algorithms that do prediction. The efficacy of prediction depends very much on the reliability of the input data. In most 
      cases of early cancer detections, the input data are fuzzy images of nodules that are too tiny and lack unique characteristics. So technically, 
      using just AI, it is hard to achieve an effective solution. There are four components in our proposed early cancer detection methodology which 
      will work cooperatively in the system: 1) specialized imaging equipment with super high resolution; 2) traditional imaging + nanotechnology 
      biosensors; 3) traditional imaging + blood test; and 4) traditional imaging + tumour growth dynamic simulation / prediction. This research project 
      involves a composite methodology comprising 2, 3 and 4, as well as some novel 4D deep learning which learns the time scale development of tumour 
      growth. Approaches 2, 3, 4 will work in parallel, then information fusion is applied, 4D graphbased evolution deep learning. Finally, XAI is built 
      using our previously published model namely White Learning Methodology for Cancer Evolution Analysis on IEEE IT Professional Magazine. Preliminary 
      results will be shared at the end of the talk.
    </p>

    <p style={{ textAlign:'justify'}}><b>Biography</b><br/>
      Simon Fong graduated from La Trobe University, Australia, with a 1st Class Honour BEng. Computer Systems degree and a PhD. Computer Science degree 
      in 1993 and 1998 respectively. Simon is now working as an Associate Professor at the Computer and Information Science Department of the University 
      of Macau. He is a co-founder of the Data Analytics and Collaborative Computing Research Group in the Faculty of Science and Technology. Prior to his 
      academic career, Simon took up various managerial and technical posts, such as systems engineer, IT consultant and e-commerce director in Australia 
      and Asia. Dr. Fong has published over 500 international conference and peer-reviewed journal papers, mostly in the areas of data mining, data stream 
      mining, e-health, meta-heuristics optimization algorithms, and their applications. He serves on the editorial boards of the IEEE JSAC Journal, IEEE IT 
      Professional Magazine, and various special issues of SCIE-indexed journals. Simon is also an active researcher with leading positions such as Vice-Chair 
      of IEEE Computational Intelligence Society (CIS) Task Force on Business Intelligence & Knowledge Management, Vice-President of Overseas Chinese 
      International Biomedical Engineering Society, and Vice-Director of International Consortium for Optimization and Modelling in Science and Industry (iCOMSI).
    </p>

    <p>Click this <a href = "https://www.simonjamesfong.com" target="_blank" rel="noreferrer">link</a> to see his further detail bio. <br/>
    </p>

  </div>
)